import { createAction, props } from '@ngrx/store';
import { SearchInfo } from '../../../models/search-info';
import { Sort } from '@angular/material/sort';
import { PageEvent } from '@angular/material/paginator';

export const setData = createAction('[Roles] Set Roles Data', props<{ data: object }>());
export const setSearchInfo = createAction('[Roles] Set search info', props<{ searchInfo: SearchInfo }>());
export const setSort = createAction('[Roles] Set sort', props<{ sort: Sort }>());
export const setPage = createAction('[Roles] Set page', props<{ page: PageEvent }>());
